import { useTranslation } from "react-i18next";
import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { TooltipHover } from "components/designV2/tooltip/tooltip";
import { formatNumber } from "utils/utils";
import { PAY_OUT_BUTTON_STYLES } from "../tips.constants";
import {
  TipBulkActions,
  TipBulkBar,
  TipBulkBarCard,
  TipBulkInfo,
  TipBulkTitle,
  TipBulkTotal,
} from "../tips.styled";
import { REMOVE_BUTTON_STYLES } from "./tips.rows.constants";
import type { TipBulkActionsBarProps } from "./tips.rows.types";

export const TipsBulkActionsBar = (
  props: TipBulkActionsBarProps,
): JSX.Element => {
  const { t } = useTranslation();
  const selectedCount = props.selectedTips.length;

  return (
    <TipBulkBar>
      <TipBulkBarCard>
        <TipBulkInfo>
          <TipBulkTitle>
            {t("Tips.SelectedDays", { count: selectedCount })}
          </TipBulkTitle>
          {props.hasBulkAction ? (
            <TipBulkTotal>
              {t("Tips.TotalSelectedTips", {
                amount: formatNumber(props.selectedTotalAmount),
                currency: t("Tips.Currency"),
              })}
            </TipBulkTotal>
          ) : (
            <TipBulkTotal>{t("Tips.NoCommonBulkActions")}</TipBulkTotal>
          )}
        </TipBulkInfo>
        <TipBulkActions>
          <SecondaryButton
            label={t("Tips.Unselect")}
            onClick={props.onClearSelection}
            size="small"
            type="button"
          />
          {props.canBulkRemove && (
            <SecondaryButton
              iconName="v2/trash"
              label={t("Tips.Remove")}
              onClick={() => {
                props.onDeleteMany(props.selectedIds);
                props.onClearSelection();
              }}
              size="small"
              styleOverrides={REMOVE_BUTTON_STYLES}
              type="button"
            />
          )}
          {props.canBulkRevert && (
            <SecondaryButton
              iconName="v2/reset"
              label={t("Tips.Revert")}
              onClick={() => {
                props.onRevertManualPayout(props.selectedIds);
                props.onClearSelection();
              }}
              size="small"
              type="button"
            />
          )}
          {props.canBulkDistribute && (
            <PrimaryButton
              iconName="v2/percent"
              label={t("Tips.Distribute")}
              onClick={() => {
                props.onDistributeMany(props.selectedIds);
                props.onClearSelection();
              }}
              size="small"
              type="button"
            />
          )}
          {!props.canBulkDistribute &&
            props.shouldShowDisabledBulkDistribute && (
              <TooltipHover text={t("TimeReports.NoTimeReports")} arrow="down">
                <PrimaryButton
                  disabled
                  iconName="v2/percent"
                  label={t("Tips.Distribute")}
                  size="small"
                  type="button"
                />
              </TooltipHover>
            )}
          {props.canBulkPayout && (
            <PrimaryButton
              iconName="v2/send"
              label={t("Tips.PayOut")}
              onClick={() => props.onOpenPayout(props.selectedTips)}
              size="small"
              styleOverrides={PAY_OUT_BUTTON_STYLES}
              type="button"
            />
          )}
        </TipBulkActions>
      </TipBulkBarCard>
    </TipBulkBar>
  );
};
